import { StoreState } from "..";

export const getFareOffersWithDetails = (state: StoreState) => state.brandedFares.fareOffersWithDetails;
/* start - flights_apex_web_fetch_branded_fare_flight_details */
export const getSelectedFareToken = (state: StoreState) => state.brandedFares.selectedFareToken;
/* end - flights_apex_web_fetch_branded_fare_flight_details */
